export const lightningEventColumnKeys = [
	'time',
	'secondsToFault',
	'latitude',
	'longitude',
	'cloud',
	'signalStrengthKA',
	'distanceM',
	'closestAssetVrns',
	'ellSemiMajM',
	'ellSemiMinM',
	'ellAngleDeg',
	'continuingCurrentProb',
	'metalDmgPotentialPctl',
	'nonMetalDmgPotentialPctl',
	'isStrikePtStart',
	'numStrokesInStrike',
] as const
export type LightningEventColumnKey = (typeof lightningEventColumnKeys)[number]

type ReportColumnSupport = {
	hasFaultTime: boolean
	hasErrorEllipses: boolean
	hasStrikeDamagePotential: boolean
	hasMultipleAssets: boolean
}

export const shownLightningEventColumnKeys = ({
	hasFaultTime,
	hasErrorEllipses,
	hasStrikeDamagePotential,
	hasMultipleAssets,
}: ReportColumnSupport): LightningEventColumnKey[] => {
	const isShown = {
		time: true,
		secondsToFault: hasFaultTime,
		latitude: true,
		longitude: true,
		cloud: true,
		signalStrengthKA: true,
		distanceM: true,
		closestAssetVrns: hasMultipleAssets,
		ellSemiMajM: hasErrorEllipses,
		ellSemiMinM: hasErrorEllipses,
		ellAngleDeg: hasErrorEllipses,
		continuingCurrentProb: hasStrikeDamagePotential,
		metalDmgPotentialPctl: hasStrikeDamagePotential,
		nonMetalDmgPotentialPctl: hasStrikeDamagePotential,
		isStrikePtStart: hasStrikeDamagePotential,
		numStrokesInStrike: hasStrikeDamagePotential,
	} satisfies Record<LightningEventColumnKey, boolean>

	return lightningEventColumnKeys.filter((key) => isShown[key])
}
